import { getCache, withCache } from '../../utils/promise/withCache.js';
const cacheKey = (id) => `blockNumber.${id}`;
export function getBlockNumberCache(id) {
    return getCache(cacheKey(id));
}
export async function getBlockNumber(client, { maxAge = client.pollingInterval } = {}) {
    const blockNumberHex = await withCache(() => client.request({
        method: 'eth_blockNumber',
    }), { cacheKey: cacheKey(client.uid), maxAge });
    return BigInt(blockNumberHex);
}
//# sourceMappingURL=getBlockNumber.js.map